// import { ReactSession } from 'react-client-session';

export const sessionSetup = async (user_id, email, fullname, admin, customer_name, contract_id, site_ids) => {

    // let current_datetime = new Date()
    // let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
  
    sessionStorage.setItem("user_id", user_id)
    sessionStorage.setItem("email", email)
    sessionStorage.setItem("fullname", fullname)
    sessionStorage.setItem("admin", admin)
    sessionStorage.setItem("customer_name", customer_name)
    sessionStorage.setItem("contract_id", contract_id)
    sessionStorage.setItem("site_ids", site_ids)
    // sessionStorage.setItem("sessionStartTime", formatted_date)
    sessionStorage.setItem("contractsLoaded", "0")
    sessionStorage.setItem("impersonate", "0")
    sessionStorage.setItem("contractImpersonate", "NULL")
    sessionStorage.setItem("siteIDsImpersonate", "NULL")
    sessionStorage.setItem("contactsLoaded", "0")
    sessionStorage.setItem("statsLoaded", "0")

    sessionStorage.setItem("target_site_id", "0")
    sessionStorage.setItem("target_job_id", "0")

    
}